<template>


    <button type="button" :class="[...day.classes, 'd', {'-sa':isSelectedArrival, '-sd': isSelectedDeparture, '-s':isSelected,  '-d': isValidDeparture}]" :data-date="day.key" :data-lt="day.ltDate"><i>{{day.day}}</i></button>

</template>

<script lang="ts">

    import { defineComponent, ref, Ref, computed, PropType, ComputedRef, inject } from 'vue';
    import { DateEntry, } from '@Components/ArrivalDeparturePicker/Types/DateEntry';

    export default defineComponent({

        props: {

            day: {
                type: Object as PropType<DateEntry>,
                required: true
            }
        },

        setup(props, context) {



            const arrivalDateLt = inject('arrivalDateLt') as ComputedRef<number | undefined>;
            const departureDateLt = inject('departureDateLt') as ComputedRef<number | undefined>;;

            // we dont need availability, we provide the valid dates..
            // const availability = inject('availability');// as reactive<AvailabilityContainer> | undefined;
            const validDepartures = inject('validDepartures') as ComputedRef<Array<number>>;


            // if i am the arrival date, i should be selected
            const isSelectedArrival = computed(() => arrivalDateLt.value !== undefined && arrivalDateLt.value == props.day.ltDate);


            // if i am the departure date, i should be selected
            const isSelectedDeparture = computed(() => departureDateLt.value !== undefined && departureDateLt.value == props.day.ltDate);

            // if i am between arrival and departure,
            // i should be selected
            const isSelected = computed(() => {

                if (isSelectedArrival.value || isSelectedDeparture.value) return true;

                // todo : determine if there is a selection, and this value is between it
                if (arrivalDateLt.value !== undefined && departureDateLt.value !== undefined) {

                    return props.day.ltDate > arrivalDateLt.value && props.day.ltDate < departureDateLt.value;
                }

                return false;

            });

            // if there is an arrival date, but no departure date,
            // i should show if i am valid as a departure date
            const isValidDeparture = computed(() => {

                return validDepartures.value.some((value, index) => index === 0 ? false : value == props.day.ltDate);

            });


            return {
                isSelectedArrival,
                isSelectedDeparture,
                isSelected,
                isValidDeparture
            };
        }
    });



</script>